import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@core/components/base-component';
import { AuthService } from '@shared/services/auth.service';

@Component({
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.less']
})
export class UnauthorizedComponent extends BaseComponent {
  public constructor(private authService: AuthService, private router: Router) {
    super();
  }


  public async login() {
    await this.authService.login();
  }
}
